import type { PropsWithChildren } from "react";

import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

const StyledCodeText = withTheme(styled.span<PropsWithTheme>`
  font-family: ${({ theme }) => theme.font.mono.family};
  font-weight: ${({ theme }) => theme.font.mono.weight.regular};
  font-size: ${({ theme }) => theme.font.mono.size.body_sm};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
  border-radius: 4px;
  padding: 2px 4px;
  background-color: ${({ theme }) => theme.color.background.tertiary};
`);

const Code = ({ children }: PropsWithChildren) => {
  return <StyledCodeText>{children}</StyledCodeText>;
};

export default Code;
